import classNames from 'classnames';

import './Spinner.scss';

export interface SpinnerProps {
  size: 'large' | 'medium' | 'small';
  className?: string;
}

/**
 * A ring in the brand colour, so it follows the tenant's and the
 * organization's rebrand. It used to be a GIF in MyFitWorld green — the one
 * MFW-coloured thing left on screen before a rebranded app had painted. The
 * ring is a mark, so it takes `primary.onSurfaceMark` (measured at 3:1 against
 * the current surface), not the `main` fill, which can vanish on a light
 * tile. While no branding is known yet (`data-mfw-branding="pending"` on the
 * root) it is neutral: `text.secondary`, which every layer derives from the
 * background, so it shows on a light surface as well as a dark one.
 */
const Spinner = ({ className, size }: SpinnerProps) => {
  return (
    <div
      className={classNames(
        'Mfw-Spinner-root',
        {
          [`Mfw-Spinner--${size}`]: true,
        },
        className,
      )}
      aria-busy="true"
      role="progressbar"
    />
  );
};

export default Spinner;
